import styled from 'styled-components';

export default function TextAreaInput(props) {
  const { value, setValue, placeholder, disabled, width } = props;

  function handleClick(e) {
  }

  function handleChange(e) {
    setValue(e.target.value);
  }

  function handleFocus(e) {
  }

  function handleBlur(e) {
  }

  return (
    <Input
      type='text'
      placeholder={placeholder}
      value={value || ''}
      disabled={disabled}
      width={width}
      onClick={handleClick}
      onChange={handleChange}
      onFocus={handleFocus}
      onBlur={handleBlur} />
    )
}

const Input = styled.textarea`
  font-family: NotoSansKR-Regular;
  font-size: 14px;
  line-height: 20px;

  width: ${props => props.width}px;
  height: 47px;

  padding: 8px;

  outline: none;
  resize: none;
  border: 1px solid ${props => props.theme.line};
  border-radius: 5px;
  color: ${props => props.theme.text};
  background-color: ${props => props.disabled ? props.theme.buttonFill : props.theme.subBackground};

  &::placeholder {
    color: ${props => props.theme.line};
  }

  transition: all 0.3s ease-in-out;
`;
